import { Hero } from "@/components/Hero";
import { AppsBento } from "@/components/AppsBento";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <AppsBento />
      <Marquee />
      <About />
      <Contact />
    </div>
  );
}
